import React, { useEffect, useRef, useState } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import Loader from "../../UI/loader";
import { scrollToTop } from "../../../JS/scrollToTop";
import { setDeviceConfigFailed, setRegPage } from "../../../action/action";
import { setGoHome, setLoginRequired } from "../../action/homeAction";
import { getUpSellItem } from "../../../action/hcommerce";
import { fetchUpsells } from "../../action/upsells";
import { CLICKED, CMSPath, EXIT, globalIV, globalSalt } from "../../../config/constant";
import { AesUtil } from "../../../JS/AesUtil";
import { sendAnalytics, setWarningPopup } from "../../../action/homeAction";
import { calculateTimeDifference, getDefaultAnalyticsLabel } from "../../JS/utility";
import { setSuccessFailPop } from '../../action/viewBillAction2'
import { saveGuestRequest } from "../../../action/guestRequest";
import { closeOrderPopUp } from "../../action/hCommerce2";


const UpsellWidget = (props) => {


    const { t } = props
    const upsellPath = "/cmsData/upsellEvents/imgStyles/";

    let room = localStorage.getItem("room");
    let widgetLaunchTime = new Date
    let aesUtil = new AesUtil(128, 1000);
    let SessionToken = localStorage.getItem("GuestJourneySessionToken");
    let label = getDefaultAnalyticsLabel({ appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : "" })

    const [showLoader, setShowLoader] = useState(false);
    const [upsellsList, setUpsellsList] = useState([]);
    const upsellsListRef = useRef([])

    const [upsellOrderData, setRenderUpsellOrderData] = useState({
        upsellId: null,
        upsellType: null,
        enableUpsellOrderDetails: false
    })
    const [selectedQPS, setSelectedQPS] = useState([])

    const [pendingRequest, setPendingRequest] = React.useState([]);
    const [acceptedRequest, setAcceptedRequest] = React.useState([]);




    const handleShowUpsellOrderDetails = (upsellData) => {

        if (!upsellData.id) {
            return;
        }

        setRenderUpsellOrderData({ upsellId: upsellData.id, upsellType: upsellData.type, enableUpsellOrderDetails: true });
    }

    const resetUpsellOrderData = () => {
        setSelectedQPS([])
        setRenderUpsellOrderData({ upsellId: null, upsellType: null, enableUpsellOrderDetails: false })
    }

    const handleGoBack = () => {

        if (upsellOrderData.enableUpsellOrderDetails) {
            resetUpsellOrderData()
            return;
        }

        props.setGoHome(true);
    }


    const removePendingRequestData = (data) => {
        setPendingRequest((prevRequests) =>
            prevRequests.filter(
                (request) =>
                    !(request.upsellId === data.upsellId && request.upsellType == data.upsellType && request.qualityPlusRequestId === data.qualityPlusRequestId)
            )
        );
    };

    const addPendingRequestData = (data) => {

        let pendingRequestData = {
            upsellId: data.upsellId,
            upsellType: data.upsellType,
            qualityPlusRequestId: data.qualityPlusRequestId
        }

        setPendingRequest((prevRequests) => {
            const isPresent = prevRequests.some(
                (request) =>
                    request.upsellId === pendingRequestData.upsellId && request.upsellType == pendingRequestData.upsellType && request.qualityPlusRequestId === pendingRequestData.qualityPlusRequestId
            );
            if (!isPresent) {
                return [...prevRequests, pendingRequestData];
            }
            return prevRequests;
        });
    };


    const addAcceptedRequestData = (data) => {
        let pendingRequestData = {
            upsellId: data.upsellId,
            upsellType: data.upsellType,
            qualityPlusRequestId: data.qualityPlusRequestId
        }

        setAcceptedRequest((prevData) => {
            const isPresent = prevData.some(
                (request) =>
                    request.upsellId === pendingRequestData.upsellId && request.upsellType == pendingRequestData.upsellType && request.qualityPlusRequestId === pendingRequestData.qualityPlusRequestId
            );
            if (!isPresent) {
                return [...prevData, pendingRequestData];
            }
            return prevData;
        });
    }


    const handleSelectQPS = (qpsID) => {
        setSelectedQPS(prevSelectedQPS => {
            if (prevSelectedQPS.includes(qpsID)) {
                return prevSelectedQPS.filter(id => id !== qpsID);
            } else {
                return [...prevSelectedQPS, qpsID];
            }
        });
    };

    const handleUpsellRequestResponse = (status, msg, pendingRequestData) => {

        removePendingRequestData(pendingRequestData);

        if (status) {
            props.closeOrderPopUp(true, "", msg || t('upsells.request_sent_msg'), false);
            addAcceptedRequestData(pendingRequestData);
        } else {
            props.closeOrderPopUp(true, "", msg || t('upsells.something_went_wrong'), true);
        }
    }

    const handleUpsellRequest = (upsellData, qualityPlusRequestId) => {

        let guestInfo = {};

        if (props.guestDetails) {
            guestInfo = props.guestDetails;
        } if (localStorage.getItem("Set_Current_Logged_In_Guest_Details")) {
            guestInfo = JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))[0];
        } else if (localStorage.getItem("X_CHECKIN_PQ_DATA") || sessionStorage.getItem("X_CHECKIN_PQ_DATA")) {
            guestInfo = JSON.parse(aesUtil.decrypt(globalSalt, globalIV, "1234567891234567", (localStorage.getItem("X_CHECKIN_PQ_DATA") || sessionStorage.getItem("X_CHECKIN_PQ_DATA"))));
        }

        if (!guestInfo.reservationNumber) {
            props.closeOrderPopUp(true, "", t('upsells.something_went_wrong'), true);
            return;
        }

        let pendingRequestData = {
            upsellId: upsellData.id,
            upsellType: upsellData.type,
            qualityPlusRequestId: qualityPlusRequestId
        }

        addPendingRequestData(pendingRequestData)


        props.saveGuestRequest(
            guestInfo,
            localStorage.getItem("GuestJourneySessionToken"),
            [qualityPlusRequestId],
            "",
            (status, msg) => handleUpsellRequestResponse(status, msg, pendingRequestData)
        );
    }


    const removeRequestedQps = (upsellData) => {

        return upsellData.map(event => {

            const updatedQualityPlusRequestList = event.qualityPlusRequestList && event.qualityPlusRequestList.length > 0 && event.qualityPlusRequestList.filter(qps => !qps.isRequested) || [];

            // Return the updated event object with the filtered qualityPlusRequestList
            if (updatedQualityPlusRequestList.length > 0) {
                return {
                    ...event,
                    qualityPlusRequestList: updatedQualityPlusRequestList
                };
            }

            return null;
        }).filter(event => event !== null);
    }

    const fetchUpsellData = () => {

        setShowLoader(true);

        fetchUpsells(props)
            .then((res) => {
                setShowLoader(false);
                if (res.status == 200) {

                    const updatedUpsellData = removeRequestedQps(res.data);
                    setUpsellsList(updatedUpsellData)
                } else {
                    props.setSuccessFailPop(true, false, "Something went wrong")
                }
            })
            .catch((err) => {
                setShowLoader(false);
                props.setSuccessFailPop(true, false, "Something went wrong")
            })

    }


    const updateShownAdhocList = () => {

        const adHocEventShownIDList = JSON.parse(localStorage.getItem("adHocEventShownIDList")) || [];
        const serverDate = props.serverTimeDatePayload.date && props.serverTimeDatePayload.date.split("T")[0];

        const updatedAdHocEventShownIDList = [...adHocEventShownIDList];
        upsellsListRef.current && upsellsListRef.current.forEach(upsell => {
            const shownAdhocData = {
                id: upsell.id,
                triggerType: upsell.type,
                adhocEventShownDate: serverDate
            };

            const existingIndex = updatedAdHocEventShownIDList.findIndex(event =>
                event.id === shownAdhocData.id && event.triggerType === shownAdhocData.triggerType
            );

            if (existingIndex > -1) {
                updatedAdHocEventShownIDList[existingIndex] = shownAdhocData;
            } else {
                updatedAdHocEventShownIDList.push(shownAdhocData);
            }
        });

        localStorage.setItem("adHocEventShownIDList", JSON.stringify(updatedAdHocEventShownIDList));
    }


    useEffect(() => {
        upsellsListRef.current = upsellsList;
    }, [upsellsList]);

    useEffect(() => {
        scrollToTop();

        let guestDetails = {}

        if (localStorage.getItem("Set_Current_Logged_In_Guest_Details")) {
            guestDetails = JSON.parse(localStorage.getItem("Set_Current_Logged_In_Guest_Details"))[0];
        } else if (localStorage.getItem("X_CHECKIN_PQ_DATA") || sessionStorage.getItem("X_CHECKIN_PQ_DATA")) {
            guestDetails = JSON.parse(aesUtil.decrypt(globalSalt, globalIV, "1234567891234567", (localStorage.getItem("X_CHECKIN_PQ_DATA") || sessionStorage.getItem("X_CHECKIN_PQ_DATA"))));
        }

        if (!props.isPreCheckinProgress && (!room || room == "null") && Object.keys(guestDetails).length == 0) {

            if (process.env.REACT_APP_INROOMTAB == "true") {
                props.setLoginRequired(true)
            } else {
                props.setRegPage(true);
            }

            return;
        } else {
            fetchUpsellData();
        }

        props.sendAnalytics(
            guestDetails,
            props.currentWidgets.displayName,
            CLICKED,
            { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget" },
            0,
            props.guestIsLoggedIn
        );

        return () => {

            updateShownAdhocList();

            let widgetCloseTime = new Date
            let duration = calculateTimeDifference(widgetLaunchTime, widgetCloseTime, 'second')

            props.sendAnalytics(
                guestDetails,
                props.currentWidgets.displayName,
                EXIT,
                { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "duration": duration },
                0,
                props.guestIsLoggedIn
            );
        }
    }, [])

    return (
        <>
            <div className={`main-container ${props.isPreCheckinProgress && "checkin-upsells"} show-upsells`}>
                <header class="inner-pages subpages">
                    {!props.disableBackButton && <a onClick={handleGoBack} class="button-back"></a>}
                    {props.next && <a onClick={props.next} class="button-next"></a>}
                    <div class="heading align-center">
                        <div class="splash-brand">
                            <img src={`${CMSPath}${props.logo}`} />
                        </div>
                    </div>
                </header>

                {upsellOrderData.enableUpsellOrderDetails ?
                    <section class="widgets spa-listing">


                        {
                            upsellsList.map((upsell) => (
                                upsell.id === upsellOrderData.upsellId && upsell.type == upsellOrderData.upsellType && (

                                    <>
                                        <div class="widget-header">
                                            {upsell.imageUri ?
                                                <div class="widget-header-img">
                                                    <img src={`${CMSPath}${upsellPath}${upsell.imageUri}`} />
                                                </div>
                                                : props.currentWidgets.widgetHeaderImageUrl &&
                                                <div class="widget-header-img">
                                                    <img src={`${CMSPath}${props.currentWidgets.widgetHeaderImageUrl}`} alt={props.currentWidgets.displayName} />
                                                </div>
                                            }
                                            <div class="widget-header-title" dangerouslySetInnerHTML={{ __html: upsell.name }}></div>
                                            <div class="widget-header-subtitle" dangerouslySetInnerHTML={{ __html: upsell.textMessage }}></div>
                                        </div>

                                        <div class="widgets offers-sub-page">

                                            <div class="row offers-list">
                                                <div class="row offer-item">

                                                    {upsell.qualityPlusRequestList && upsell.qualityPlusRequestList.length > 0 &&
                                                        <div class="widgets">
                                                            {
                                                                upsell.qualityPlusRequestList.map((qualityPlusRequest) => (


                                                                    <div class="row offers-list">
                                                                        <div class="row offer-item">


                                                                            {qualityPlusRequest.imageName && <div class="offer-img">
                                                                                <img src={`${CMSPath}${upsellPath}${qualityPlusRequest.imageName}`} />
                                                                            </div>}



                                                                            <div class="offer-body">
                                                                                <div class="offer-title" style={{ color: "#000 !important" }} dangerouslySetInnerHTML={{ __html: qualityPlusRequest.name }} ></div>
                                                                                <div class="offer-body-text" dangerouslySetInnerHTML={{ __html: qualityPlusRequest.description }} ></div>
                                                                            </div>



                                                                            <div class="offer-controls">
                                                                                <div class="offer-pricing">
                                                                                    {qualityPlusRequest.price &&
                                                                                        <>
                                                                                            <div class="offer-pricing-heading">{t(`upsells.price`)}</div>
                                                                                            <div class="offer-pricing-amount">{qualityPlusRequest.price}</div>
                                                                                        </>
                                                                                    }
                                                                                </div>
                                                                                <div class="offer-buttons">
                                                                                    {
                                                                                        pendingRequest.some((pendingRequestData) => {
                                                                                            return upsell.id == pendingRequestData.upsellId && upsell.type == pendingRequestData.upsellType && qualityPlusRequest.id == pendingRequestData.qualityPlusRequestId;
                                                                                        }) ?
                                                                                            <>
                                                                                                <button disabled class="button"><div class="loader-ring"><img src="layout_2/assests/loader.png" /></div> {t('upsells.accepting')}</button> :
                                                                                                {/* <button disabled class="button">{t('upsells.remove')}</button> */}
                                                                                            </>
                                                                                            :
                                                                                            acceptedRequest.some((acceptedRequestData) => {
                                                                                                return upsell.id == acceptedRequestData.upsellId && upsell.type == acceptedRequestData.upsellType && qualityPlusRequest.id == acceptedRequestData.qualityPlusRequestId;
                                                                                            })
                                                                                                ?
                                                                                                <>
                                                                                                    <button disabled class="button">{t('upsells.accepted')}</button>
                                                                                                </>
                                                                                                :
                                                                                                <>
                                                                                                    <button onClick={() => handleUpsellRequest(upsell, qualityPlusRequest.id)} class="button">{t('upsells.accept')}</button>
                                                                                                    {/* <button onClick={() => handleRemoveUpsellFromList(upsell.id, upsell.type, qualityPlusRequest.id)} class="button">{t('upsells.remove')}</button> */}
                                                                                                </>
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))
                                                            }
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                        <div class="multi-tips-controls">
                                            <button class="button secondary w-100" onClick={handleGoBack} >{t('upsells.back')}</button>
                                        </div>
                                    </>
                                )
                            ))
                        }

                    </section >
                    :
                    <section class="widgets">

                        <div class="widget-header">
                            {props.currentWidgets.widgetHeaderImageUrl &&
                                <div class="widget-header-img">
                                    <img src={`${CMSPath}${props.currentWidgets.widgetHeaderImageUrl}`} alt={props.currentWidgets.displayName} />
                                </div>
                            }
                            <div class="widget-header-title">{props.title || t(`upsells.heading`)}</div>
                            <div class="widget-header-subtitle">{props.subtitle || t(`upsells.sub_heading`)}</div>
                        </div>


                        <div class="widgets">
                            {
                                upsellsList.length > 0
                                    ?
                                    upsellsList.map((upsell) => {
                                        return (
                                            <div class="widgets">
                                                <div class="row offers-list" onClick={() => handleShowUpsellOrderDetails(upsell)}>
                                                    <div class="row offer-item">

                                                        {upsell.imageUri && <div class="offer-img">
                                                            <img src={`${CMSPath}${upsellPath}${upsell.imageUri}`} />
                                                        </div>}


                                                        <div class="offer-body">
                                                            <div class="offer-title" style={{ color: "#000 !important" }} dangerouslySetInnerHTML={{ __html: upsell.name }} ></div>
                                                            <div class="offer-body-text" dangerouslySetInnerHTML={{ __html: upsell.textMessage }} ></div>
                                                        </div>

                                                    </div>
                                                </div>

                                                {
                                                    upsell.qualityPlusRequestList && upsell.qualityPlusRequestList.length > 0 ?
                                                        <div class="widgets">
                                                            {
                                                                upsell.qualityPlusRequestList.map((qualityPlusRequest) => (

                                                                    <div class="row offers-list">
                                                                        <div class="row offer-item">


                                                                            {qualityPlusRequest.imageName && <div class="offer-img">
                                                                                <img src={`${CMSPath}${upsellPath}${qualityPlusRequest.imageName}`} />
                                                                            </div>}



                                                                            <div class="offer-body">
                                                                                <div class="offer-title" style={{ color: "#000 !important" }} dangerouslySetInnerHTML={{ __html: qualityPlusRequest.name }} ></div>
                                                                                <div class="offer-body-text" dangerouslySetInnerHTML={{ __html: qualityPlusRequest.description }} ></div>
                                                                            </div>

                                                                            <div class="offer-controls">
                                                                                <div class="offer-pricing">
                                                                                    {qualityPlusRequest.price &&
                                                                                        <>
                                                                                            <div class="offer-pricing-heading">{t(`upsells.price`)}</div>
                                                                                            <div class="offer-pricing-amount">{qualityPlusRequest.price}</div>
                                                                                        </>
                                                                                    }
                                                                                </div>

                                                                                <div class="offer-buttons">
                                                                                    {
                                                                                        pendingRequest.some((pendingRequestData) => {
                                                                                            return upsell.id == pendingRequestData.upsellId && upsell.type == pendingRequestData.upsellType && qualityPlusRequest.id == pendingRequestData.qualityPlusRequestId;
                                                                                        }) ?
                                                                                            <>
                                                                                                <button disabled class="button"><div class="loader-ring"><img src="layout_2/assests/loader.png" /></div> {t('upsells.accepting')}</button> :
                                                                                                {/* <button disabled class="button">{t('upsells.remove')}</button> */}
                                                                                            </>
                                                                                            :
                                                                                            acceptedRequest.some((acceptedRequestData) => {
                                                                                                return upsell.id == acceptedRequestData.upsellId && upsell.type == acceptedRequestData.upsellType && qualityPlusRequest.id == acceptedRequestData.qualityPlusRequestId;
                                                                                            })
                                                                                                ?
                                                                                                <>
                                                                                                    <button disabled class="button">{t('upsells.accepted')}</button>
                                                                                                </>
                                                                                                :
                                                                                                <>
                                                                                                    <button onClick={() => handleUpsellRequest(upsell, qualityPlusRequest.id)} class="button">{t('upsells.accept')}</button>
                                                                                                    {/* <button onClick={() => handleRemoveUpsellFromList(upsell.id, upsell.type, qualityPlusRequest.id)} class="button">{t('upsells.remove')}</button> */}
                                                                                                </>
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                ))
                                                            }
                                                        </div>
                                                        :
                                                        <div class="widgets">{t('upsells.no_qps')}</div>
                                                }


                                            </div>
                                        )
                                    })
                                    :
                                    <div class="widgets user-info no_upsells">
                                        <div class="widgets msg-section">
                                            <div class="tile-selection tile-container thumbnails">
                                                <div class="tile-selection-text">
                                                    <div class="tile-selection-desc">{t('upsells.no_upsells')}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                            }
                        </div>
                    </section>
                }

            </div>
            {showLoader && <Loader displayMsg={"Fetching data..."} />}
        </>
    )
}

const mapStateToProps = state => {
    return {
        serverTimeDate: state.store.home.serverTimeDate.date,
        serverTimeDatePayload: state.store.home.serverTimeDate || {},
        currentWidgets: state.store.sideNavBar.currentWidget,
        currentHomePage: state.store2.currentHomePage,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
    }
}
export default connect(mapStateToProps, { setRegPage, setLoginRequired, setDeviceConfigFailed, setGoHome, sendAnalytics, setSuccessFailPop, setWarningPopup, saveGuestRequest, closeOrderPopUp })(withTranslation('translations')(UpsellWidget));